import { CopyIcon, LinkedinIcon, Share2, ShareIcon, XIcon } from 'lucide-react'
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  EmailIcon,
  FacebookIcon,
  WhatsappIcon,
  TelegramIcon,
  XIcon as XIcon2,
  LinkedinShareButton,
  PinterestShareButton,
  RedditShareButton,
  TumblrShareButton,
  TumblrIcon,
  ViberShareButton,
  ViberIcon,
  PinterestIcon,
  RedditIcon,
  TwitterIcon,
  InstapaperShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from 'react-share'
import { Button } from '../ui/button'

const ShareButton = ({
  url,
  title = 'Soukna',
  description = 'Soukna property #Soukna',
  media,
  shareLabel = 'Share',
}: {
  url: string
  title?: string
  description?: string
  media?: string
  shareLabel?: string
}) => {
  const copyToClipboard = (link: any) => {
    navigator.clipboard.writeText(link).then(
      () => {
        console.log('Link copied!')
      },
      (err) => {
        console.log('Failed to copy the link.')
      },
    )
  }

  return (
    <div className="relative group/share">
      <Button
        variant="outline"
        size="sm"
        className="rounded-lg bg-card text-typography border border-border"
      >
        <span className="mr-2">{shareLabel}</span>
        <Share2 size={16} />
      </Button>
      <div className="absolute top-[15px] right-full bg-transparent invisible opacity-0 duration-300 ease-in-out group-hover/share:visible group-hover/share:opacity-100 z-50">
        <div className="grid grid-cols-4 items-center justify-start gap-6 bg-white shadow p-3 mt-5 rounded-lg w-[260px]">
          <EmailShareButton
            url={url}
            subject={`Soukna property: ${title}`}
            body={`Soukna property description: ${description} `}
            className=" flex items-center justify-center"
          >
            <EmailIcon round={true} className="!w-8 !h-8 duration-300 hover:scale-105" />
          </EmailShareButton>

          <FacebookShareButton
            url={url}
            hashtag="#Soukna"
            className="flex items-center justify-center"
          >
            <FacebookIcon round className="!w-8 !h-8 duration-300 hover:scale-105" />
          </FacebookShareButton>

          <WhatsappShareButton
            url={url || ''}
            title={'Soukna'}
            image={media}
            className="min-w-[20px] flex items-center justify-center "
          >
            <WhatsappIcon round={true} className="!w-8 !h-8 duration-300 hover:scale-105" />
          </WhatsappShareButton>

          <TelegramShareButton
            url={url || ''}
            title={'Soukna'}
            className="min-w-[20px] flex items-center justify-center "
          >
            <TelegramIcon round={true} className="!w-8 !h-8 duration-300 hover:scale-105" />
          </TelegramShareButton>

          <TwitterShareButton url={url || ''} className=" flex items-center justify-center">
            <XIcon2 round={true} className="!w-8 !h-8 duration-300 hover:scale-105" />
          </TwitterShareButton>
          <TelegramShareButton
            title="Soukna"
            url={url || ''}
            className=" flex items-center justify-center"
          >
            <TelegramIcon round={true} className="!w-8 !h-8 duration-300 hover:scale-105" />
          </TelegramShareButton>

          <button
            title="copy"
            type="button"
            onClick={() => copyToClipboard(url || '')}
            className="min-w-[20px] flex items-center justify-center "
          >
            <CopyIcon className="duration-300 hover:scale-110" />
          </button>
        </div>
      </div>
    </div>
  )
}
export default ShareButton
